/* eslint-disable react/jsx-filename-extension */
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import * as OfflinePluginRuntime from 'offline-plugin/runtime';
import amplitude from 'amplitude-js/amplitude';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import createStore from './store/createStore';
import i18n from './utils/i18n/i18n';
import App from './containers/App';

import(
  /* webpackMode: "eager" */ `./styles/${__BRAND_NAME__}/main.sass` // __BRAND__.name doesn't work for some reason
);

if (__PROD__) {
  const appInsights = new ApplicationInsights(
    {
      config: {
        connectionString: __APPLICATIONINSIGHTS_CONNECTION_STRING__,
        enableAutoRouteTracking: true,
      },
    }
  );
  // appInsights.loadAppInsights();
  appInsights.trackPageView();
  // initialize Service workers
  OfflinePluginRuntime.install({
    onUpdateReady: () => {
      OfflinePluginRuntime.applyUpdate();
    },
  });
}
//
// Store Initialization
// ------------------------------------
let store = {};

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById('root');

let render = (AppComponent) => {
  ReactDOM.render(
    <I18nextProvider i18n={i18n}><AppComponent store={store} /></I18nextProvider>,
    MOUNT_NODE,
  );
};

// Development Tools, globals: See webpack.config and DefinePlugin
// ------------------------------------
if (__DEV__) {
  if (module.hot) {
    const renderApp = render;
    const renderError = (error) => {
      ReactDOM.render(<div>{JSON.stringify(error)}</div>, MOUNT_NODE);
    };

    render = (AppComponent) => {
      try {
        renderApp(AppComponent);
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
        renderError(e);
      }
    };

    // Setup hot module replacement
    module.hot.accept([
      './containers/App',
      './routes/index',
    ], () => setImmediate(() => {
      ReactDOM.unmountComponentAtNode(MOUNT_NODE);
      render(App);
    }),);
  }
}

// Let's Go!
// ------------------------------------
if (!__TEST__) {
  amplitude.getInstance().init(__AMPLITUDE_KEY__);
  createStore(window.__INITIAL_STATE__).then((createdStore) => {
    store = createdStore;
    render(App);
  });
}
